export function scrollToTop(el: HTMLElement | typeof window = window) {
  el.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}
